export default {
    created() {
   
        window.addEventListener('mousewheel', this.onWheel)   
    },
    methods: {
        onWheel(evt) {
            // TweenMax.set(this.$refs.container, { y: +10, ease: Cubic.easeOut }) 
            // TweenMax.to(this.$refs.container, 1, { y: 0 })
        },  
    }
}